<ng-content />

<p-popover
  #roleGrantsPopover
  appendTo="body"
  styleClass="role-grants-popover-panel"
  (onHide)="onPopoverHide()"
  showTransitionOptions="0ms"
  hideTransitionOptions="0ms"
  [motionOptions]="noMotionOptions"
  [focusOnShow]="false">
  <section
    class="role-grants-popover"
    (mouseenter)="cancelScheduledClose()"
    (mouseleave)="scheduleClose()">
    <header class="role-grants-popover__header">
      <strong>{{ title() }}</strong>
      @if (level() !== 'none') {
        <span
          class="level-pill"
          [class.level-pill--read]="level() === 'read'"
          [class.level-pill--write]="level() === 'write'"
          [class.level-pill--manage]="level() === 'manage'">
          {{ levelLabel(level()) }}
        </span>
      }
    </header>

    @if (grants().length > 0) {
      <div class="role-grants-popover__grants">
        @for (grant of sortedGrants(); track grant) {
          <span>{{ grant }}</span>
        }
      </div>
    } @else {
      <p>{{ 'SETTINGS_ACCESS.ROLES.NO_GRANTS_SELECTED' | translate }}</p>
    }
  </section>
</p-popover>
